import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const formatDateValue = (val) => {
    if (!val) return "";
    if (dayjs(val, "DD-MMM-YYYY", true).isValid()) return val;
    const parsed = dayjs(val);
    return parsed.isValid() ? parsed.format("DD-MMM-YYYY") : String(val);
};


export const formatTime = (time) => {
    if (!time) return "";

    return String(time).replace(/(\d{1,2}:\d{2}):\d{2}/, "$1");
};